import React from "react";
import {Grid, useMediaQuery, useTheme} from "@mui/material";
import {SupervisionChatList} from "./components/supervision-chat-list";
import {SupervisionConversation} from "./components/supervision-conversation";
import {CreateConversation} from "./components/create-conversation";
import isElectron from "../../../utils/functions";
import {useParams} from "react-router-dom";
import {MobileUnavailable} from "../../../components/MobileUnavailable";

export const SupervisionPage = ({project}) => {
  const {conversationId} = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const height = `calc(100dvh - ${isElectron() ? "50px" : "48px"})`;

  if (isMobile) {
    return <MobileUnavailable/>;
  }

  return (
    <>
      <Grid container spacing={0} alignItems={"stretch"} sx={{maxHeight: height, height: "100%"}}>
        <Grid item xs={12} sm={6} md={4} lg={3}
              sx={{
                py: 2, maxHeight: height,
                borderRight: 1, borderColor: "divider",
                display: "flex", flexDirection: "column"
              }}
        >
          <SupervisionChatList project={project} />
        </Grid>
        {
          conversationId ?
            <>
              <Grid item xs={12} sm={6} md={8} lg={9}
                    sx={{
                      maxHeight: height,
                      height: "100%",
                      display: "flex", flexDirection: "column",
                      position: "relative",
                    }}
              >
                <SupervisionConversation project={project} />
              </Grid>
            </>
            :
            <Grid item xs={12} sm={6} md={8} lg={9}
                  sx={{
                    maxHeight: height,
                    height: "100%",
                    borderRight: 1, borderColor: "divider",
                    display: "flex", flexDirection: "column",
                    alignItems: "center", justifyContent: "space-around"
                  }}
            >
              <CreateConversation project={project} />
            </Grid>
        }
      </Grid>
    </>
  )
}